import React from 'react';
import { Typography, Container } from '@mui/material';

const ManageProfile = () => {
  return (
    <Container>
      <Typography variant="h4" style={{ margin: '20px 0' }}>
        Manage Profile
      </Typography>
      {/* Add your profile management form or details here */}
    </Container>
  );
};

export default ManageProfile; 